import axios from 'axios';
const URI_RETIRO = '/pastos/api/v1/retiros/';

class RetiroService {
  async obtemRetiros(filtro = {}) {
    return axios.get(`${URI_RETIRO}?filter=${JSON.stringify(filtro)}`, { headers: {} });
  }
}
export default new RetiroService();
